import React from 'react';
import PropTypes from 'prop-types';
import Form from './stormForm';
import { connect } from 'react-redux';

class Create extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Create';
    	this.handleSave = this.handleSave.bind(this)
    	this.handleCancel = this.handleCancel.bind(this)
    }
    handleSave(state) {

    }
    handleCancel(e) {

    }
    render() {
        return (
        	<Form onSave={this.handleSave} onCancel={this.handleCancel} onChange={this.handleChange} />
        );
    }
}

export default connect(function(state) {
	var {connection} = state;
	return {
		connection
	}
})(Create);



// WEBPACK FOOTER //
// ./src/browser/components/storms/createStorm.js